<template>
  <h1>Uh-Oh!</h1>
  <h3>Network error. Please take a deep breath and
    <a href="#" @click="$router.go(-1)">click here</a>
    to try again.
  </h3>
</template>
